import { Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    palletTitle: {
        fontSize: 16,
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 15,
    },
});

interface StandardTitleProps {
    title: string;
}

export const StandardTitle: React.FC<StandardTitleProps> = ({ title }) => {
    return <Text style={styles.palletTitle}>{title}</Text>;
};